export const _Set_note_for_checkout = (note) => {
  return {
    type: "SET_CHECKOUT_NOTE",
    note,
  };
};

export const _Clear_note_for_checkout = () => {
  return {
    type: "CLEAR_CHECKOUT_NOTE",
  };
};
